import PropTypes from 'prop-types';

export default function Gauge({ value }) {
    return (
        <div className="card gauge-card">
            <h4>Overall Completion</h4>

            <div className="gauge-circle">
                <span>{value}%</span>
            </div>

            <p className="gauge-subtext">Across all KPIs</p>
        </div>
    );
}

Gauge.propTypes = {
    value: PropTypes.number.isRequired
};
